<template>
  <!-- 通用栏目页：左侧菜单 + 右侧内容（列表 / 详情），覆盖除首页外的所有顶部导航 -->
  <div class="pt-channel">
    <div class="pt-channel__inner" v-loading="loadingMenu">
      <!-- 加载中遮罩 -->
      <!-- <div v-if="loadingMenu" class="pt-channel__loading">
        <span>加载中…</span>
      </div> -->

      <!-- <template v-else> -->
        <!-- 左侧菜单 -->
        <aside class="pt-side">
          <!-- {{ menuTree }} -->
          <h2 class="pt-side__head" @click="onHeadClick">{{ channelName }}</h2>
          <nav v-if="menuTree.length > 0" class="pt-side__menu">
            <side-menu-item
              :items="menuTree"
              :level="0"
              :active-key="activeSectionKey"
              :collapsed-keys="collapsedKeys"
              @go-section="goSection"
              @parent-click="onParentClick"
              @toggle-collapse="toggleCollapse"
            />
          </nav>
        </aside>

        <!-- 右侧内容 -->
        <section class="pt-main" v-loading="loadingContent">
          <header class="pt-main__head">
            <h3 class="pt-main__title">{{ panelTitle }}</h3>
          </header>

          <!-- 详情 -->
          <article v-if="viewMode === 'detail'" class="pt-article">
            <div v-if="fromList || article.date" class="pt-article__meta">
              <span v-if="article.date">发布时间：{{ article.date }}</span>
              <span v-if="article.date && article.source" class="pt-article__sep">|</span>
              <span v-if="article.source">来源：{{ article.source }}</span>
            </div>
            <div v-if="article.isRichText" class="pt-article__body" v-html="article.html" />
            <div v-else class="pt-article__body">
              <p v-for="(p, i) in article.paragraphs" :key="i">{{ p }}</p>
            </div>
            <div v-if="fromList" class="pt-article__foot">
              <a class="pt-btn" @click="backToList">&lt; 返回列表</a>
            </div>
          </article>

          <!-- 列表 -->
          <div v-else class="pt-list">
            <ul class="pt-list__ul">
              <li
                v-for="(n, i) in currentList"
                :key="n.id || i"
                class="pt-list__li"
                @click="openArticle(i)"
              >
                <span class="pt-list__dot" />
                <span class="pt-list__name">{{ n.title }}</span>
                <time class="pt-list__date">{{ formatDate(n.date || n.publishTime) }}</time>
              </li>
            </ul>

            <!-- 分页 -->
            <div v-if="totalPages > 1" class="pt-pager">
              <span
                class="pt-pager__btn"
                :class="{ 'is-disabled': currentPage <= 1 }"
                @click="goPage(currentPage - 1)"
              >上一页</span>
              <span
                v-for="p in visiblePages"
                :key="p"
                class="pt-pager__num"
                :class="{ 'is-active': p === currentPage }"
                @click="goPage(p)"
              >{{ p }}</span>
              <span
                class="pt-pager__btn"
                :class="{ 'is-disabled': currentPage >= totalPages }"
                @click="goPage(currentPage + 1)"
              >下一页</span>
            </div>

            <!-- 空数据 -->
            <div v-if="!loadingContent && currentList.length === 0" class="pt-channel__empty">
              <el-empty description="暂无数据" />
            </div>
          </div>
        </section>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import { cmsNewsTree, cmsNewsPage } from '@/http/api/CmsApi'
import { GetArticleDetail } from '@/http/api/ArticleApi'
import { channels, makeArticle, getChannelConfig } from './portalData'
import SideMenuItem from './components/SideMenuItem.vue'
import axios from 'axios'

export default {
  name: 'PortalChannel',
  components: { SideMenuItem },
  data () {
    return {
      // 菜单树（由 API 返回）
      menuTree: [],
      // 菜单加载状态
      loadingMenu: false,
      // 内容加载状态
      loadingContent: false,
      // 当前文章列表
      currentList: [],
      // 当前文章详情
      currentArticle: null,
      // 当前分类的 remarks 内容（不为空时直接展示富文本，不请求新闻列表）
      currentRemarks: '',
      // 父级菜单收起状态（默认全部收起）
      collapsedKeys: {},
      // 请求取消令牌
      cancelTokenSource: null,
      // 分页
      currentPage: 1,
      pageSize: 12,
      totalPages: 1
    }
  },
  computed: {
    channelKey () {
      return this.$route.params.channel
    },
    // 栏目配置（含 categoryId）
    channelConfig () {
      return getChannelConfig(this.channelKey) || { key: this.channelKey, label: '', categoryId: null }
    },
    // 栏目名称（API 正常时从 navChannels 取；fallback 用 channels）
    channelName () {
      var cfg = this.channelConfig
      if (cfg && cfg.label) return cfg.label
      var ch = channels[this.channelKey]
      return ch ? ch.name : ''
    },
    // 栏目对应的 CMS 分类 ID
    categoryId () {
      return this.channelConfig ? this.channelConfig.categoryId : null
    },
    // 当前选中菜单项 key（跟踪路由 section，第一条无 remarks 时不默认选中）
    activeSectionKey () {
      if (this.$route.params.section) return this.$route.params.section
      // 第一条有 remarks 才自动高亮，否则等用户点击
      if (this.menuTree[0] && this.menuTree[0].remarks) return this.menuTree[0].key
      return ''
    },
    // 当前选中的菜单项：优先取路由 section 参数，否则默认第一项（递归搜索所有层级）
    section () {
      var key = this.$route.params.section
      if (!key) return this.menuTree[0] || { key: '', label: '', categoryId: null }
      var found = this.findItemByKey(this.menuTree, key)
      return found || this.menuTree[0] || { key: '', label: '', categoryId: null }
    },
    // 打开的文章索引（列表 -> 详情，通过 ?a= 传递）
    articleIndex () {
      var a = this.$route.query.a
      return (a === undefined || a === null || a === '') ? -1 : Number(a)
    },
    fromList () {
      return this.articleIndex >= 0
    },
    viewMode () {
      if (this.fromList) return 'detail'
      // 当前分类有 remarks 时直接展示详情
      if (this.currentRemarks) return 'detail'
      return 'list'
    },
    article () {
      if (this.fromList) {
        var item = this.currentList[this.articleIndex]
        if (item && item.content) {
          // API 返回的详情数据
          return {
            title: item.title || '',
            date: item.date || item.publishDate || '',
            source: item.source || '中国交通运输协会',
            paragraphs: item.content
              ? item.content.split('\n').filter(function (p) { return p.trim() })
              : makeArticle(item).paragraphs
          }
        }
        return makeArticle(item)
      }
      // 当前分类有 remarks 时直接展示 remarks 富文本内容
      if (this.currentRemarks) {
        return {
          title: this.section.label || this.channelName,
          date: '',
          source: '',
          isRichText: true,
          html: this.currentRemarks
        }
      }
      if (this.currentArticle) {
        var art = this.currentArticle
        return {
          title: art.title || '',
          date: art.date || art.publishDate || '',
          source: art.source || '中国交通运输协会',
          paragraphs: art.content
            ? art.content.split('\n').filter(function (p) { return p.trim() })
            : makeArticle(art).paragraphs
        }
      }
      return makeArticle({ title: this.section.label })
    },
    panelTitle () {
      if (this.viewMode === 'detail') return this.article.title
      // 无菜单选中时显示 side__head 文案
      if (!this.activeSectionKey) return this.channelName
      return this.section.label || this.channelName
    },
    // 可见页码（最多展示 7 个）
    visiblePages () {
      var total = this.totalPages
      var cur = this.currentPage
      if (total <= 1) return []
      if (total <= 7) {
        var arr = []
        for (var i = 1; i <= total; i++) { arr.push(i) }
        return arr
      }
      var pages = []
      if (cur <= 4) {
        for (var j = 1; j <= 5; j++) { pages.push(j) }
        pages.push('...')
        pages.push(total)
      } else if (cur >= total - 3) {
        pages.push(1)
        pages.push('...')
        for (var k = total - 4; k <= total; k++) { pages.push(k) }
      } else {
        pages.push(1)
        pages.push('...')
        for (var l = cur - 1; l <= cur + 1; l++) { pages.push(l) }
        pages.push('...')
        pages.push(total)
      }
      return pages
    }
  },
  watch: {
    // 路由 channel 变化时重新加载菜单
    channelKey: {
      immediate: true,
      handler: function (newKey, oldKey) {
        if (newKey !== oldKey) {
          this.loadMenuTree()
        }
      }
    },
    // 路由变化时滚动到顶部并加载内容
    '$route': {
      handler: function () {
        window.scrollTo(0, 0)
        if (this.menuTree.length > 0) {
          this.loadContent()
        }
      }
    }
  },
  methods: {
    /**
     * 1. 从 CMS API 获取左侧菜单目录树
     *    调用 cmsNewsTree 传入当前栏目的 categoryId 作为父节点
     */
    loadMenuTree: function () {
      var self = this
      var catId = this.categoryId
      // 立即清空旧菜单数据，防止 $route watcher 触发 loadContent 用旧数据请求
      self.menuTree = []
      self.rootRemarks = ''
      if (!catId) {
        self.$nextTick(function () { self.loadContent() })
        return
      }

      self.loadingMenu = true
      cmsNewsTree({ id: catId }).then(function (res) {
        self.loadingMenu = false
        if (res.code === '000' || res.code === '1') {
          var data = res.result || {}
          if (Array.isArray(data)) {
            // 数组格式 [{...}]
            if (data.length === 1 && data[0].remarks) {
              // 单条数据且 remarks 有值 → 作为根节点 remarks，菜单隐藏
              self.rootRemarks = data[0].remarks
              self.menuTree = []
            } else {
              self.rootRemarks = ''
              self.menuTree = data.length > 0 ? self.transformMenuTree(data) : []
            }
          } else {
            // 对象格式 { remarks, children }
            self.rootRemarks = data.remarks || ''
            if (data.remarks) {
              // 1. 第一级 remarks 有值 → 菜单隐藏
              self.menuTree = []
            } else {
              // 2. 第一级 remarks 没值 → 看 children
              var hasChildren = data.children && Array.isArray(data.children) && data.children.length > 0
              if (hasChildren) {
                // 2.1 children 有数据 → 正常处理
                self.menuTree = self.transformMenuTree(data.children)
              } else {
                // 2.2 children 为空 → 菜单隐藏
                self.menuTree = []
              }
            }
          }
          self.menuTree = self.unwrapMenuTree(self.menuTree)
          // 默认全部收起
          self.initCollapsed()
        } else {
          self.rootRemarks = ''
          self.menuTree = []
        }
        self.$nextTick(function () { self.loadContent() })
      }).catch(function () {
        self.loadingMenu = false
        self.rootRemarks = ''
        self.menuTree = []
        self.$nextTick(function () { self.loadContent() })
      })
    },

    /**
     * 将 CMS 返回的分类树转换为菜单格式
     * API 返回格式预计为：
     * [{ id, name/label, children: [...] }]
     * 转换为：
     * [{ key: 'id', label: 'name', categoryId: id, children: [...] }]
     */
    transformMenuTree: function (nodes) {
      if (!nodes || !Array.isArray(nodes)) return []
      var self = this
      return nodes.map(function (n) {
        var item = {
          key: String(n.id || n.categoryId || ''),
          label: n.name || n.label || n.categoryName || '',
          categoryId: n.id || n.categoryId || null,
          remarks: n.remarks || '',
          href: n.href || n.url || ''
        }
        if (n.children && n.children.length) {
          item.children = self.transformMenuTree(n.children)
        }
        return item
      })
    },

    /**
     * 若菜单第一条数据没有 remarks 但有 children，则向下展开一级
     * 递归直到第一条数据有 remarks 或没有 children 为止
     */
    unwrapMenuTree: function (tree) {
      if (!tree || tree.length !== 1) return tree
      var first = tree[0]
      if (!first.remarks && first.children && first.children.length > 0) {
        return this.unwrapMenuTree(first.children)
      }
      if (!first.remarks && first.children.length === 0) {
        return []
      }
      return tree
    },

    /**
     * 2. 加载当前菜单项对应的文章列表
     *    调用 cmsNewsPage 传入分类 ID 分页获取
     */
    loadContent: function () {
      var self = this
      var sec = this.section
      var hasSectionParam = !!self.$route.params.section

      if (this.fromList) {
        self.loadArticleDetail(self.currentList[this.articleIndex])
        return
      }

      if (hasSectionParam && sec && sec.categoryId) {
        // 点击了左侧菜单项 → 页数重置为 1
        self.currentPage = 1
        if (sec.remarks) {
          self.setRemarksContent(sec.remarks)
        } else {
          self.fetchNewsList(sec.categoryId)
        }
        return
      }

      // 默认进入（无 section 参数）
      // 1. 第一级 remarks 有值 → 右侧显示 remarks
      if (self.rootRemarks) {
        self.setRemarksContent(self.rootRemarks)
        return
      }

      // 2.1 children 有数据
      if (self.menuTree.length > 0 && self.menuTree[0].categoryId) {
        self.currentPage = 1
        // 2.1.1 第一条数据 remarks 有值 → 显示 remarks
        if (self.menuTree[0].remarks) {
          self.setRemarksContent(self.menuTree[0].remarks)
          return
        }
        // 2.1.2 第一条数据 remarks 没值 → 使用根节点分类 ID 请求文章列表
        self.fetchNewsList(self.categoryId)
        return
      }

      // 2.2 children 为空 → 使用第一级分类 ID 请求文章列表
      self.currentPage = 1
      self.fetchNewsList(self.categoryId)
    },

    /**
     * 请求新闻列表
     */
    fetchNewsList: function (categoryId) {
      var self = this
      self.currentRemarks = ''
      self.loadingContent = true
      cmsNewsPage({
        classId: categoryId,
        pageNo: self.currentPage,
        pageSize: self.pageSize
      }).then(function (res) {
        self.loadingContent = false
        if (res.code === '000' || res.code === '1') {
          var data = res.result
          self.currentList = data.records || data.list || data.content || []
          self.totalPages = data.pages || data.totalPage || Math.ceil((data.total || 0) / self.pageSize) || 1
        } else {
          self.currentList = []
          self.totalPages = 1
        }
      }).catch(function () {
        self.loadingContent = false
        self.currentList = []
        self.totalPages = 1
      })
    },

    /**
     * 设置 remarks 富文本为当前展示内容
     */
    setRemarksContent: function (remarks) {
      this.currentRemarks = remarks
      this.currentList = []
      this.totalPages = 1
      this.currentPage = 1
      this.loadingContent = false
    },

    /**
     * 3. 加载文章详情
     */
    loadArticleDetail: function (item) {
      if (!item) return
      // 如果点击的条目已有 content 字段，无需再请求
      if (item.content) {
        this.currentArticle = item
        return
      }
      var self = this
      var articleId = item.id || item.articleId || ''
      if (!articleId) {
        self.currentArticle = item
        return
      }
      self.loadingContent = true
      GetArticleDetail({ id: articleId }).then(function (res) {
        self.loadingContent = false
        if (res.code === '000' || res.code === '1') {
          self.currentArticle = res.result || item
        } else {
          self.currentArticle = item
        }
      }).catch(function () {
        self.loadingContent = false
        self.currentArticle = item
      })
    },

    // 点击父级菜单：有子级则切换收起/展开，否则直接跳转
    onParentClick: function (m) {
      if (!m) return
      if (m.href) {
        window.location.href = m.href
        return
      }
      if (m.children && m.children.length) {
        this.toggleCollapse(m.key)
      } else {
        this.goSection(m)
      }
    },

    // 初始化全部收起
    initCollapsed: function () {
      var self = this
      var map = {}
      self.menuTree.forEach(function (m) {
        if (m.children && m.children.length) {
          map[m.key] = true
        }
      })
      self.collapsedKeys = map
    },

    // 切换收起/展开
    toggleCollapse: function (key) {
      this.$set(this.collapsedKeys, key, !this.collapsedKeys[key])
    },

    // 切换菜单项
    goSection: function (m) {
      if (!m) return
      if (m.href) {
        window.location.href = m.href
        return
      }
      var target = '/portal/' + this.channelKey + '/' + m.key
      if (this.$route.fullPath !== target) {
        this.$router.push(target)
      }
    },

    // 打开文章详情（列表 -> 详情）
    // 点击新闻列表 → 跳转详情页
    openArticle: function (i) {
      var item = this.currentList[i]
      var id = item ? (item.id || item.articleId || '') : ''
      if (id) {
        this.$router.push({
          path: '/portal/detail/' + id,
          query: {
            channel: this.channelKey,
            section: this.section ? this.section.key : ''
          }
        })
      }
    },

    // 返回列表
    backToList: function () {
      this.currentArticle = null
      this.$router.push('/portal/' + this.channelKey + '/' + this.section.key)
    },

    // 翻页
    goPage: function (p) {
      if (p === '...') return
      p = Number(p)
      if (p < 1 || p > this.totalPages || p === this.currentPage) return
      this.currentPage = p
      window.scrollTo(0, 0)
      var hasSectionParam = !!this.$route.params.section
      if (hasSectionParam) {
        var sec = this.section
        if (sec && sec.categoryId && !sec.remarks) {
          this.fetchNewsList(sec.categoryId)
        }
      } else {
        this.fetchNewsList(this.categoryId)
      }
    },

    // 格式化日期为 YYYY-MM-DD
    formatDate: function (str) {
      if (!str) return ''
      return String(str).substring(0, 10)
    },

    // 递归查找菜单项
    findItemByKey: function (nodes, key) {
      if (!nodes || !nodes.length) return null
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].key === key) return nodes[i]
        if (nodes[i].children && nodes[i].children.length) {
          var found = this.findItemByKey(nodes[i].children, key)
          if (found) return found
        }
      }
      return null
    },

    // 点击 side__head → 清空菜单选中，路由 watcher 会自动重新加载列表
    onHeadClick: function () {
      if (!this.currentRemarks && this.categoryId) {
        this.currentPage = 1
        var target = '/portal/' + this.channelKey
        if (this.$route.path !== target) {
          this.$router.replace(target)
        } else {
          // 已在当前栏目，直接刷新列表
          this.fetchNewsList(this.categoryId)
        }
      }
    },

    // 回到首页
    goHome: function () {
      this.$router.push('/portal')
    }
  }
}
</script>

<style lang="less" scoped>
/* 不透明灰底盖住页头的蓝色装饰带，保证栏目页背景干净 */
.pt-channel {
  position: relative;
  z-index: 1;
  background: var(--pt-bg, #f4f6f9);
}
.pt-channel__inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  // padding: 16px 12px 32px;
}

/* 加载 & 空状态 */
.pt-channel__loading,
.pt-channel__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--pt-muted, #9ca3af);
  font-size: 14px;
}

/* ===== 左侧菜单 ===== */
.pt-side {
  margin-bottom: 16px;
}
.pt-side__head {
  margin: 0;
  padding: 0 16px;
  height: 48px;
  line-height: 48px;
  background: #0a447c;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  border-radius: 6px 6px 0 0;
  cursor: pointer;
  user-select: none;
}
.pt-side__head:hover {
  opacity: 0.92;
}
/* 默认（窄屏）：单行横向滚动胶囊菜单 */
.pt-side__menu {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  padding: 10px 8px;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-top: 0;
  border-radius: 0 0 6px 6px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.pt-side__menu::-webkit-scrollbar { height: 0; }
.pt-side__item {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #f3f5f8;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.pt-side__item-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 收起/展开箭头 */
.pt-side__toggle {
  flex: none;
  width: 16px;
  height: 16px;
  position: relative;
  transition: transform 0.2s;
}
.pt-side__toggle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #999;
}
.pt-side__toggle.is-expanded::after {
  transform: translate(-50%, -50%) rotate(0deg);
}
.pt-side__item:hover {
  color: #0a447c;
}
.pt-side__item.is-active {
  background: #0a447c;
  color: #fff;
}
/* 子菜单在窄屏隐藏（桌面端竖向展开） */
.pt-side__sub {
  display: none;
}

/* ===== 右侧内容 ===== */
.pt-main {
  min-height: 420px;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 6px;
}
.pt-main__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  height: 52px;
  border-bottom: 1px solid var(--pt-line-2, #e5e7eb);
}
.pt-main__title {
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #1a1f2b;
  font-size: 18px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pt-main__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 18px;
  border-radius: 999px;
  background: #0a447c;
}
.pt-main__crumb {
  display: none;
  flex: none;
  color: var(--pt-muted, #9ca3af);
  font-size: 12px;
}
.pt-main__crumb i {
  margin: 0 6px;
  font-style: normal;
}
.pt-main__crumb a {
  color: var(--pt-muted, #9ca3af);
  cursor: pointer;
}
.pt-main__crumb a:hover {
  color: #0a447c;
}

/* 详情 */
.pt-article {
  padding: 20px 20px 28px;
}
.pt-article__meta {
  padding-bottom: 14px;
  margin-bottom: 18px;
  border-bottom: 1px dashed var(--pt-line-2, #e5e7eb);
  text-align: center;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
}
.pt-article__sep {
  margin: 0 10px;
}
.pt-article__body p {
  margin: 0 0 16px;
  text-indent: 2em;
  line-height: 1.9;
  color: #333;
  font-size: 15px;
}
.pt-article__foot {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--pt-line-2, #e5e7eb);
}
.pt-btn {
  display: inline-block;
  padding: 7px 16px;
  border-radius: 4px;
  background: #0a447c;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}
.pt-btn:hover {
  opacity: 0.9;
}

/* 列表 */
.pt-list {
  padding: 4px 16px 16px;
}
.pt-list__ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pt-list__li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 4px;
  border-bottom: 1px dashed var(--pt-line-2, #e5e7eb);
  cursor: pointer;
}
.pt-list__dot {
  flex: none;
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: #c9ced6;
  transition: background 0.2s;
}
.pt-list__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
  font-size: 15px;
  transition: color 0.2s;
}
.pt-list__date {
  flex: none;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
}
.pt-list__li:hover .pt-list__name {
  color: #0a447c;
}
.pt-list__li:hover .pt-list__dot {
  background: #0a447c;
}

/* 分页 */
.pt-pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 22px 0 6px;
}
.pt-pager__btn,
.pt-pager__num {
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  line-height: 32px;
  text-align: center;
  border: 1px solid var(--pt-line-2, #e5e7eb);
  border-radius: 4px;
  color: #555;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.pt-pager__num:hover {
  border-color: #0a447c;
  color: #0a447c;
}
.pt-pager__num.is-active {
  background: #0a447c;
  border-color: #0a447c;
  color: #fff;
}
.pt-pager__btn.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

/* ===== 桌面端：左右布局 ===== */
@media (min-width: 768px) {
  .pt-channel__inner {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    padding: 20px 16px 40px;
  }
  .pt-side {
    flex: none;
    width: 220px;
    margin-bottom: 0;
  }
  /* 竖向菜单 */
  .pt-side__menu {
    display: block;
    overflow: visible;
    padding: 6px 0 10px;
  }
  .pt-side__item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 13px 16px 13px 22px;
    border-radius: 0;
    border-left: 3px solid transparent;
    background: transparent;
    border-bottom: 1px solid #f2f4f7;
    white-space: normal;
  }
  .pt-side__item:hover {
    background: #f5f8fc;
  }
  .pt-side__item.is-active {
    background: #eef4fb;
    border-left-color: #e8873a;
    color: #0a447c;
    font-weight: 600;
  }
  .pt-side__sub {
    display: block;
    background: #f8fafc;
    border-bottom: 1px solid #f2f4f7;
  }
  .pt-side__subitem {
    display: block;
    padding: 11px 16px 11px 38px;
    color: #666;
    font-size: 13px;
    cursor: pointer;
    transition: color 0.2s, background 0.2s;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .pt-side__subitem::before {
    content: '·';
    margin-right: 6px;
    color: #9aa4b2;
  }
  .pt-side__subitem:hover {
    color: #0a447c;
  }
  .pt-side__subitem.is-active {
    color: #0a447c;
    font-weight: 600;
    background: #eef4fb;
  }
  .pt-main {
    flex: 1 1 auto;
    min-width: 0;
  }
  .pt-main__crumb {
    display: block;
  }
  .pt-article {
    padding: 26px 28px 32px;
  }
}
</style>
